<div class="container kiosk-db-page">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Admin Kiosk DB</h2>
    <div class="header-actions">
      <span class="summary-chip">Secciones: {{ rootEntries().length }}</span>
      <button mat-stroked-button class="refresh-table-button" (click)="loadKioskDb()">
        <mat-icon>refresh</mat-icon>
        Recargar
      </button>
    </div>
  </div>

  <mat-card class="table-card kiosk-db-card">
    <div class="data-table-state data-table-state--loading" *ngIf="loading">
      <mat-spinner diameter="34"></mat-spinner>
      <span>Cargando base de datos del kiosk...</span>
    </div>

    <ng-container *ngIf="!loading">
      <div class="state-card state-card--error" *ngIf="errorMessage">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

      <ng-container *ngIf="!errorMessage">
        <div class="breadcrumb" *ngIf="!isRootNode()">
          <button mat-button type="button" class="breadcrumb-button" (click)="goToRoot()">Root</button>
          <ng-container *ngFor="let segment of path; let i = index">
            <mat-icon>chevron_right</mat-icon>
            <button
              mat-button
              type="button"
              class="breadcrumb-button"
              [disabled]="i === path.length - 1"
              (click)="goToPath(i)">
              {{ segment.label }}
            </button>
          </ng-container>
        </div>

        <div class="root-list" *ngIf="isRootNode(); else nodeContent">
          <button
            type="button"
            class="root-item"
            *ngFor="let entry of rootEntries()"
            (click)="openRoot(entry)">
            <div class="root-item-main">
              <mat-icon>chevron_right</mat-icon>
              <span class="root-item-label">{{ entry.key }}</span>
            </div>
            <span class="node-badge" *ngIf="isExpandable(entry.value)">{{ expandLabel(entry.value) }}</span>
          </button>

          <div class="state-card" *ngIf="!hasVisibleRootData()">
            <mat-icon>storage</mat-icon>
            <span>No hay datos para mostrar.</span>
          </div>
        </div>

        <ng-template #nodeContent>
          <div class="node-summary">
            <span class="summary-chip">Tipo: {{ currentNodeTypeLabel() }}</span>
            <span class="summary-chip" *ngIf="currentNodeCountLabel()">{{ currentNodeCountLabel() }}</span>
          </div>

          <ng-container [ngSwitch]="currentNodeKind()">
            <app-data-table
              *ngSwitchCase="'array-objects'"
              [dataSource]="arrayObjectRows()"
              [displayedColumns]="tableColumns()"
              [rowClickable]="true"
              [emptyMessage]="'No hay elementos disponibles.'"
              (rowClick)="openArrayObjectRow($event.row)">
              <ng-container *ngFor="let column of tableColumns()" [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef>{{ column === '__index' ? '#' : column }}</th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="column === '__index'; else valueCell">
                    {{ row.__index }}
                  </ng-container>

                  <ng-template #valueCell>
                    <button
                      *ngIf="isExpandable(row[column]); else primitiveCell"
                      mat-stroked-button
                      type="button"
                      class="node-link"
                      (click)="openArrayObjectCell(row, column, $event)">
                      {{ expandLabel(row[column]) }}
                    </button>

                    <ng-template #primitiveCell>
                      <span class="primitive-value">{{ formatPrimitive(row[column]) }}</span>
                    </ng-template>
                  </ng-template>
                </td>
              </ng-container>
            </app-data-table>

            <div class="key-value-list" *ngSwitchCase="'object'">
              <button
                type="button"
                class="key-value-row"
                *ngFor="let entry of objectEntries()"
                [class.key-value-row--clickable]="isExpandable(entry.value)"
                (click)="openObjectEntry(entry)">
                <span class="key-value-key">{{ entry.key }}</span>
                <span class="key-value-value" *ngIf="isExpandable(entry.value); else objectPrimitive">
                  <span class="node-badge">{{ expandLabel(entry.value) }}</span>
                  <mat-icon>chevron_right</mat-icon>
                </span>
                <ng-template #objectPrimitive>
                  <span class="primitive-value">{{ formatPrimitive(entry.value) }}</span>
                </ng-template>
              </button>
            </div>

            <div class="key-value-list" *ngSwitchCase="'array-values'">
              <button
                type="button"
                class="key-value-row"
                *ngFor="let entry of arrayValueEntries()"
                [class.key-value-row--clickable]="isExpandable(entry.value)"
                (click)="openArrayValueEntry(entry)">
                <span class="key-value-key">[{{ entry.index }}]</span>
                <span class="key-value-value" *ngIf="isExpandable(entry.value); else arrayPrimitive">
                  <span class="node-badge">{{ expandLabel(entry.value) }}</span>
                  <mat-icon>chevron_right</mat-icon>
                </span>
                <ng-template #arrayPrimitive>
                  <span class="primitive-value">{{ formatPrimitive(entry.value) }}</span>
                </ng-template>
              </button>
            </div>

            <div class="state-card" *ngSwitchDefault>
              <mat-icon>notes</mat-icon>
              <span>{{ formatPrimitive(currentNode()) }}</span>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-container>
  </mat-card>
</div>
